// Registro unico delle superfici nascondibili per ruolo (dashboard_config).
// Aggiungere una superficie = una riga qui; compare nell'editor e va rispettata
// dal relativo consumer (TodayPage / App.tsx / SettingsPage).

export type DashboardTileDef = {
  key: string;
  icon: string;
  title: string;
  subtitle: string;
  gradient: 'blue' | 'teal' | 'amber' | 'rose' | 'slate' | 'green';
  route: string;
  flag?: 'collettiva' | 'food_cost' | 'event_quotes' | 'transport_documents';
};

type ModuleFlag = NonNullable<DashboardTileDef['flag']>;

// NB: spostato da TodayPage. Le `key` sono persistite in dashboard_config →
// NON rinominarle.
export const DASHBOARD_TILES: DashboardTileDef[] = [
  { key: 'temperature', icon: '🌡️', title: 'Temperature', subtitle: 'Registra una rilevazione', gradient: 'blue', route: '/haccp/temperatures' },
  { key: 'pulizie', icon: '🧽', title: 'Pulizie', subtitle: 'Segna pulizia fatta', gradient: 'blue', route: '/haccp/cleaning' },
  { key: 'etichetta', icon: '🏷️', title: 'Etichetta', subtitle: 'Stampa preparazione', gradient: 'blue', route: '/haccp/labels' },
  { key: 'pest-control', icon: '🐀', title: 'Pest control', subtitle: 'Controllo rapido e interventi', gradient: 'blue', route: '/haccp/pest-control' },
  { key: 'scadenze', icon: '⏰', title: 'Scadenze', subtitle: 'Lotti in scadenza', gradient: 'blue', route: '/haccp/expirations' },
  { key: 'magazzino', icon: '📦', title: 'Magazzino', subtitle: 'Prodotti, lotti & giacenze', gradient: 'amber', route: '/warehouse' },
  { key: 'documenti', icon: '📥', title: 'DDT/Fattura', subtitle: 'Carica foto, PDF o galleria', gradient: 'amber', route: '/documents/capture' },
  { key: 'documenti-trasporto', icon: '🚚', title: 'Documenti di trasporto', subtitle: 'DDT vendita e trasferimenti lotti', gradient: 'green', route: '/documents/transport', flag: 'transport_documents' },
  { key: 'tracciabilita', icon: '🔎', title: 'Tracciabilità', subtitle: 'Lotto → fornitore & fattura', gradient: 'amber', route: '/haccp/trace-search' },
  { key: 'ricette', icon: '📖', title: 'Ricette', subtitle: 'Ricette & semilavorati', gradient: 'rose', route: '/haccp/recipes' },
  { key: 'food-cost', icon: '💶', title: 'Food Cost ristorante', subtitle: 'Costo ricette, food cost % & margine', gradient: 'rose', route: '/haccp/food-cost', flag: 'food_cost' },
  { key: 'event-quotes', icon: '🗓️', title: 'Sale Trattenimenti / Catering', subtitle: 'Eventi, preventivi e approvvigionamenti', gradient: 'rose', route: '/business/event-quotes', flag: 'event_quotes' },
  { key: 'menu', icon: '🍽️', title: 'Menù', subtitle: 'Menu pubblico digitale', gradient: 'rose', route: '/settings/menu/manage' },
  { key: 'controllo-olio', icon: '🧪', title: 'Controllo olio', subtitle: 'Verifica e sostituzione', gradient: 'teal', route: '/haccp/oil-control' },
  { key: 'controllo-acrilammide', icon: '🍞', title: 'Controllo acrilammide', subtitle: 'Cottura e confronto cromatico', gradient: 'teal', route: '/haccp/acrylamide-control' },
  { key: 'export-registri', icon: '📄', title: 'Export registri', subtitle: 'PDF A4 firmati per ASL', gradient: 'slate', route: '/haccp/registri' },
  { key: 'registri-compila', icon: '📝', title: 'Registri da compilare', subtitle: 'Taratura, pest control…', gradient: 'slate', route: '/haccp/registri-compila' },
  { key: 'manuale', icon: '📘', title: 'Manuale', subtitle: 'Autocontrollo HACCP', gradient: 'slate', route: '/haccp/manuale' },
  { key: 'guida', icon: '📖', title: 'Guida', subtitle: "Come si usa l'app · FAQ", gradient: 'slate', route: '/guida' },
  { key: 'richieste-fornitura', icon: '🧾', title: 'Richieste fornitura', subtitle: '1 · Ordini in arrivo dalle destinazioni', gradient: 'green', route: '/warehouse/supply-requests', flag: 'collettiva' },
  { key: 'pianifica-produzione', icon: '🗓️', title: 'Pianifica produzione', subtitle: '2 · Aggrega ordini + menù del giorno', gradient: 'green', route: '/warehouse/production-plan', flag: 'collettiva' },
  { key: 'da-produrre-oggi', icon: '🍳', title: 'Comanda cucina', subtitle: '3a · Piatti + ingredienti per gli chef', gradient: 'green', route: '/warehouse/production-todo', flag: 'collettiva' },
  { key: 'smistamento-destinazioni', icon: '📦', title: 'Riassunto per destinazione', subtitle: '3b · Piatti per destinazione e reparto', gradient: 'green', route: '/warehouse/production-destinations', flag: 'collettiva' },
  { key: 'fabbisogno-produzione', icon: '📤', title: 'Scarico merce', subtitle: '4 · Scarica la merce del giorno (FIFO)', gradient: 'green', route: '/warehouse/production-sheet', flag: 'collettiva' },
  { key: 'scheda-produzione', icon: '📋', title: 'Scheda produzione', subtitle: '5 · Scheda HACCP giornaliera (dal piano)', gradient: 'green', route: '/warehouse/production-day', flag: 'collettiva' },
  { key: 'spedizioni', icon: '🚚', title: 'Spedizioni', subtitle: '6 · Evadi ordini → DDT per destinazione', gradient: 'green', route: '/warehouse/shipments', flag: 'collettiva' },
  // T-403: anagrafica destinazioni in dashboard (decisione owner 2026-07-02),
  // scoped sulla zona della sede attiva — non più tra le voci di Impostazioni.
  { key: 'destinazioni', icon: '🏫', title: 'Destinazioni', subtitle: 'Strutture servite dalla zona', gradient: 'green', route: '/settings/destinations', flag: 'collettiva' },
];

export type SurfaceItem = { key: string; icon: string; label: string; flag?: ModuleFlag };
export type VisibilitySection = { id: 'home' | 'tabs' | 'settings'; title: string; items: SurfaceItem[] };

// Schede in basso spegnibili. Oggi/Impostazioni NON in lista = sempre visibili
// (anti-blocco).
const TAB_SURFACES: SurfaceItem[] = [
  { key: 'tab.warehouse', icon: '📦', label: 'Scheda Magazzino' },
  { key: 'tab.documents', icon: '📥', label: 'Scheda Documenti' },
];

// Voci di Impostazioni spegnibili. Audit/Diagnostica esclusi = già owner-only.
const SETTINGS_SURFACES: SurfaceItem[] = [
  { key: 'settings.business', icon: '🏢', label: 'Dati locale' },
  { key: 'settings.staff', icon: '👥', label: 'Personale' },
  { key: 'settings.printer', icon: '🖨️', label: 'Stampante' },
  { key: 'settings.reports', icon: '📊', label: 'Report ASL' },
  { key: 'settings.sdi', icon: '🧾', label: 'SDI e-fatture' },
  { key: 'settings.recipe-qty', icon: '🥣', label: 'Quantità ricette' },
];

export const VISIBILITY_SECTIONS: VisibilitySection[] = [
  { id: 'home', title: 'Home (quadrati)', items: DASHBOARD_TILES.map((t) => ({ key: t.key, icon: t.icon, label: t.title, flag: t.flag })) },
  { id: 'tabs', title: 'Schede in basso', items: TAB_SURFACES },
  { id: 'settings', title: 'Impostazioni', items: SETTINGS_SURFACES },
];

export function allSurfaceKeys(): string[] {
  return VISIBILITY_SECTIONS.flatMap((s) => s.items.map((i) => i.key));
}

export type ModuleCapabilities = {
  collettiva: boolean;
  foodCost: boolean;
  eventQuotes: boolean;
  transportDocuments: boolean;
};

/** Gate puro condiviso dalla Home e dall'editor "Cosa vede il personale". */
export function isTileCapabilityEnabled(flag: DashboardTileDef['flag'], capabilities: ModuleCapabilities): boolean {
  if (flag === 'collettiva') return capabilities.collettiva;
  if (flag === 'food_cost') return capabilities.foodCost;
  if (flag === 'event_quotes') return capabilities.eventQuotes;
  if (flag === 'transport_documents') return capabilities.transportDocuments;
  return true;
}

export function visibilitySectionsForCapabilities(capabilities: ModuleCapabilities): VisibilitySection[] {
  return VISIBILITY_SECTIONS.map((section) => ({
    ...section,
    items: section.items.filter((item) => isTileCapabilityEnabled(item.flag, capabilities)),
  })).filter((section) => section.items.length > 0);
}
